import React from "react";
import { useMsal } from "@azure/msal-react";
import "../styles/platform.css";

function WaitingScreen() {
  const { instance, accounts } = useMsal();
  const user = accounts[0];

  const handleLogout = () => {
    instance.logoutRedirect({
      account: user,
      postLogoutRedirectUri: window.location.origin,
    });
  };

  return (
    <div className="waiting-screen">
      <div className="waiting-card">
        <div className="waiting-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="9" />
            <path d="M12 6v6l4 2" />
          </svg>
        </div>

        <span className="waiting-badge">Pending Approval</span>
        <h2>Onboarding Submitted!</h2>
        <p className="waiting-message">
          Your profile is under review by the administrator.
          You'll get access to the platform once approved.
        </p>

        {/* Progress tracker */}
        <div className="waiting-steps">
          <div className="waiting-step waiting-step--done">
            <span className="waiting-step__dot">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </span>
            <span className="waiting-step__label">Submitted</span>
          </div>
          <div className="waiting-step-bar waiting-step-bar--on" />
          <div className="waiting-step waiting-step--active">
            <span className="waiting-step__dot">2</span>
            <span className="waiting-step__label">Review</span>
          </div>
          <div className="waiting-step-bar" />
          <div className="waiting-step waiting-step--todo">
            <span className="waiting-step__dot">3</span>
            <span className="waiting-step__label">Access</span>
          </div>
        </div>

        <div className="waiting-info">
          <span className="waiting-email">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="5" width="18" height="14" rx="2" />
              <path d="M3 7l9 6 9-6" />
            </svg>
            {user?.username}
          </span>
          <span className="waiting-date">
            Submitted: {new Date().toLocaleDateString()}
          </span>
        </div>

        <button className="waiting-logout-btn" onClick={handleLogout}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />
          </svg>
          Sign Out
        </button>
      </div>
    </div>
  );
}

export default WaitingScreen;
